import { CategoryActionTypes, CategoryStateReducer, SET_CATEGORY } from './types';

const INITIAL_STATE: CategoryStateReducer = {
  data: [],
};

const categoryReducer = (state = INITIAL_STATE, action: CategoryActionTypes) => {
  switch (action.type) {
    case SET_CATEGORY:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
export default categoryReducer;
